export interface UiState {
  loading: boolean;
}

export const initialUiState: UiState = {
  loading: false,
};
